import { render } from "./recharge_payment.vue?vue&type=template&id=6ecb0dc0&scoped=true"
import script from "./recharge_payment.vue?vue&type=script&lang=js"
export * from "./recharge_payment.vue?vue&type=script&lang=js"

import "./recharge_payment.vue?vue&type=style&index=0&id=6ecb0dc0&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\project\\forex\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ecb0dc0"]])

export default __exports__